module.exports = __webpack_public_path__ + "static/media/3.0647e5c8.jpg";